import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel', 'overlay']

  initialize() {
    this.dragging = false
    this.currentTranslateY = 0
    this.frameRequest = null
    this.nextClientY = null
  }

  connect() {
    this.responsiveSubmenu = this.element.closest('responsive-submenu')
    this.resetPosition()
  }

  disconnect() {
    this.flushPendingDrag()
    this.toggleWillChange(false)
  }

  open() {
    this.responsiveSubmenu?.setAttribute('is-open', 'true')
  }

  close() {
    this.responsiveSubmenu?.removeAttribute('is-open')
    this.resetPosition()
    if (this.responsiveSubmenu) {
      this.dispatch("close", { prefix: "submenu", target: window, detail: { id: this.responsiveSubmenu.dataset.submenuId } })
    }
  }

  startDrag(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return

    this.dragging = true
    this.height = this.panelTarget.offsetHeight
    this.lastY = event.clientY
    this.toggleWillChange(true)

    this.panelTarget.style.transition = 'none'
    if (this.hasOverlayTarget) this.overlayTarget.style.transition = 'none'
    event.target.setPointerCapture(event.pointerId)
  }

  drag(event) {
    if (!this.dragging) return

    this.nextClientY = event.clientY
    if (this.frameRequest) return
    this.frameRequest = requestAnimationFrame(() => {
      this.frameRequest = null
      if (this.nextClientY === null) return
      this.applyDrag(this.nextClientY)
      this.nextClientY = null
    })
  }

  endDrag(event) {
    if (!this.dragging) return

    this.flushPendingDrag()
    this.dragging = false

    if (event.target.hasPointerCapture?.(event.pointerId)) {
      event.target.releasePointerCapture(event.pointerId)
    }

    this.panelTarget.style.transition = ''
    if (this.hasOverlayTarget) this.overlayTarget.style.transition = ''
    this.toggleWillChange(false)

    const threshold = this.height * 0.5

    if (this.currentTranslateY > threshold) {
      this.close()
    } else {
      this.resetPosition()
    }
  }

  applyDrag(clientY) {
    const deltaStep = clientY - this.lastY
    if (Math.abs(deltaStep) < 1) return
    this.lastY = clientY

    let translate = this.currentTranslateY + deltaStep
    translate = Math.max(0, Math.min(this.height, translate))
    this.currentTranslateY = translate

    const progress = Math.min(1, translate / this.height)
    this.panelTarget.style.transform = `translateY(${translate}px)`
    if (this.hasOverlayTarget) this.overlayTarget.style.opacity = `${1 - progress}`
  }

  resetPosition() {
    this.currentTranslateY = 0
    this.panelTarget.style.transform = ''
    if (this.hasOverlayTarget) this.overlayTarget.style.opacity = ''
  }

  flushPendingDrag() {
    if (this.frameRequest) {
      cancelAnimationFrame(this.frameRequest)
      this.frameRequest = null
    }

    if (this.nextClientY !== null) {
      this.applyDrag(this.nextClientY)
      this.nextClientY = null
    }
  }

  toggleWillChange(enable) {
    this.panelTarget.style.willChange = enable ? 'transform' : ''
    if (this.hasOverlayTarget) this.overlayTarget.style.willChange = enable ? 'opacity' : ''
  }
}
